import React from "react";
import {
  makeStyles,
  Checkbox,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import {
  EXISTING_STOP,
  NEW_STOP,
  SHOW_MATCHING_POSTCODES,
  SPLIT_INTO,
  SPLIT_TO,
  NO_VALID_STOPS_AVAILABLE,
} from "../../../constants/strings";
import RADIO_STOPS from "../../../enums/radioStops";
import NestedSelect from "../../NestedSelect";
import SliderCard from "../../SliderCard";
import palette from "../../styles/palette";

const useStyles = makeStyles(({ typography }) => ({
  label: {
    marginLeft: 0,
    marginRight: typography.pxToRem(20),
  },
  selectingButtons: {
    marginBottom: typography.pxToRem(19),
  },
  selectingButton: {
    padding: 0,
    marginRight: typography.pxToRem(13),
    color: palette.typography.black.solid,
    "& svg": {
      fontSize: `${typography.pxToRem(18)}`,
    },
  },
}));

const SplitInto = ({
  handleChangeSelectedStopType,
  isNewStopType,
  onChangeShouldMatchPostcodes,
  shouldMatchPostcodes,
  selectedStop,
  setSelectedStop,
  dropdownStopsOptions,
  disabled,
}) => {
  const classes = useStyles();

  return (
    <SliderCard title={SPLIT_TO}>
      <div className={classes.selectingButtons}>
        <FormControlLabel
          label={NEW_STOP}
          className={classes.label}
          control={
            <Radio
              size="small"
              disableRipple
              color="default"
              label={NEW_STOP}
              value={RADIO_STOPS.NEW_STOP}
              onChange={handleChangeSelectedStopType}
              checked={isNewStopType}
              className={classes.selectingButton}
              disabled={disabled}
            />
          }
        />
        <FormControlLabel
          label={EXISTING_STOP}
          className={classes.label}
          control={
            <Radio
              size="small"
              disableRipple
              color="default"
              value={RADIO_STOPS.EXISTING_STOP}
              onChange={handleChangeSelectedStopType}
              checked={!isNewStopType}
              className={classes.selectingButton}
              disabled={disabled}
            />
          }
        />
        {!isNewStopType && (
          <FormControlLabel
            label={SHOW_MATCHING_POSTCODES}
            className={classes.label}
            control={
              <Checkbox
                onChange={onChangeShouldMatchPostcodes}
                checked={shouldMatchPostcodes}
                color="default"
                checkedIcon={<CheckBoxOutlinedIcon />}
                disableRipple
                className={classes.selectingButton}
                disabled={disabled}
              />
            }
          />
        )}
      </div>
      {!isNewStopType && (
        <NestedSelect
          value={selectedStop}
          onChange={setSelectedStop}
          options={dropdownStopsOptions}
          label={
            dropdownStopsOptions.length ? SPLIT_INTO : NO_VALID_STOPS_AVAILABLE
          }
          disabled={disabled || !dropdownStopsOptions.length}
        />
      )}
    </SliderCard>
  );
};

export default SplitInto;
